<template>
  <main-layout>
    <div class="row marketing" style="padding:2em;">
        <div class="col-lg-12">
        <h3 style="margin-bottom:1em;">User Submissions</h3>
        
            <div v-for="item in getSubmissionsAndReviews" style="margin-bottom:2em;">
                
                <div v-if="item.reviewUserId">
                <!--    <div class="submission">-->
                <!--      <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">-->
                <!--        <p>Learning Community: {{item.lCId}}</p>-->
                <!--        <p>Chapter: {{item.chapterId}}</p>-->
    
                <!--        <span class="card-date">{{ new Date(item.submissionDate).toDateString() }}</span>-->
                <!--        <span style="font-size: 1em;">Submission</span> by <b>{{ item.submissionUserEmail }}</b>:-->
                <!--      </div>-->
                <!--      <i style="white-space: pre-wrap">{{ item.submissionContent }}</i>-->
                <!--    </div>-->
                <!--    <div class="review">-->
                <!--      <div style="padding-bottom: 2em; color: rgba(0,0,0,.54);">-->
                <!--        <span class="card-date">{{ new Date(item.reviewDate).toDateString() }}</span>-->
                <!--        <span style="font-size: 1em;">Review</span> by <b>{{ item.reviewUserEmail }}</b>:-->
                <!--      </div>-->
                <!--      <i style="white-space: pre-wrap">{{ item.reviewContent }}</i>-->
                <!--    </div> -->
                </div>
                
                <div v-else>
                    <p>Learning Community: {{item.lCId}}, Chapter: {{item.chapterId}}</p>
                    <p><b>Assignment:</b>
                        <div v-html="item.submissionAssignment"></div>
                    </p>
                    <div class="submission user-answer-review">
                      <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">

                        <span class="card-date">{{ new Date(item.submissionDate).toDateString() }}</span>
                        <span style="font-size: 1em;">Submission</span> by <b>{{ item.submissionDisplayName }}</b>:
                      </div>
                      <i style="white-space: pre-wrap">{{ item.submissionContent }}</i>
                    </div>
                    <form >
                        <div class="form-group row">
                            <label for="message-text" class="col-form-label" style="margin-bottom: 1em"></label>
                            <textarea class="form-control" id="message-text" placeholder="Enter Review" rows="8" v-model="review.content"></textarea>
                        </div>
                        <div class="form-group row">
                            <label for="ReviewRating" class="col-form-label" style="margin-bottom: 1em; font-size: 1.2em">Rating (max {{item.submissionAssignmentPoints}})</label>
                             <input class="form-control" id="ReviewRating" type="number" name="quantity" min="1" :max="item.submissionAssignmentPoints" v-model="review.rating">
                        </div>


                        <a class="btn btn-outline-primary btn-lg btn-block" @click="addReview(item)">Submit</a>
                    </form>  
                </div>
            </div>
        </div>
    </div>
  </main-layout>
</template>

<script>
import { store } from './../store/store.js';
import MainLayout from './MainLayout.vue';
import { dbReviewsRef } from './../firebaseConfig'
import { dbUserCollectionRef } from './../firebaseConfig'



export default {
    data() {
        return{
            review:{
            reviewUserId: null,
            reviewUserEmail: null,
            submissionUserId: null,
            submissionDisplayName: null,
            content:'',
            rating: null,
            chapterId: null,
            lCId: null,
            date: Date.now()
            },
            reviews: this.$store.getters.getReviews,
            userCollection: this.$store.getters.getUserCollection
        }
    },
    components: {
        MainLayout
    },
    computed: {
        currentUser(){
            return this.review.userId = this.$store.getters.currentUser.uid;
        },
        getSubmission() {
            var subdata = this.$store.getters.getSubmission2;
            // console.log(subdata)
            return subdata
        },
        getReview(chapterId) {
            var reviewData = this.reviews
                // console.log(reviewData);
            if(reviewData){
                var review = reviewData.filter( review => {
                    return  (review.chapterId == chapterId);
                });
                // console.log(review);
                return review;
            }
        },
        getUserCollection(subUId){
        var uC = this.$store.getters.getUserCollection;
        //console.log(subUId)
        if(uC && subUId){
          var userData = uC.filter( newData => {
              return  (newData.uid == subUId );
          });
        }
        return userData[0]
        },
        getSubmissionsAndReviews() {
                    var submissions = this.$store.getters.getSubmission2;
                    // console.log("All Submissions")
                    // console.log(submissions)
                    
                    var reviews = this.$store.getters.getReviews;
                    // console.log("All reviews")
                    // console.log(reviews)
                    
                    
                    var submissionsAndReviews = [];
                    for (var i = 0; i < submissions.length; i++) {
                            var review = reviews.filter( review => {
                                return  (
                                    review.lCId == submissions[i].lCId &&
                                    review.chapterId == submissions[i].chapterId &&
                                    review.submissionUserId == submissions[i].userId
                                );
                            });
                            // console.log("review")
                            // console.log(review)
                            if (review[0]){
                                submissionsAndReviews.push( { 
                                    "lCId":submissions[i].lCId,
                                    "chapterId":submissions[i].chapterId,
                                    "submissionUserId":submissions[i].userId,
                                    "submissionContent":submissions[i].content,
                                    "submissionDate":submissions[i].date,
                                    "submissionDisplayName":submissions[i].displayName,
                                    "submissionassignmentPoints":submissions[i].assignmentPoints,
                                    "reviewUserId":review[0].reviewUserId,
                                    "reviewDisplayName":review[0].reviewDisplayName,
                                    "reviewContent":review[0].content,
                                    "reviewDate":review[0].date
                                } );              
                            } else {
                                submissionsAndReviews.push( { 
                                    "lCId":submissions[i].lCId,
                                    "chapterId":submissions[i].chapterId,
                                    "submissionUserId":submissions[i].userId,
                                    "submissionContent":submissions[i].content,
                                    "submissionDate":submissions[i].date,
                                    "submissionDisplayName":submissions[i].displayName,
                                    "submissionAssignmentPoints":submissions[i].assignmentPoints,
                                    "submissionAssignment":submissions[i].assignment,

                                } );
                            }
                    }
                    // console.log("submissionsAndReviews")
                    // console.log(submissionsAndReviews)
                    return submissionsAndReviews;
                }

    },
    methods: {
      addReview(SubmissionItem) {
        this.review.reviewUserId = this.$store.getters.currentUser.uid;
        this.review.reviewDisplayName = this.$store.getters.currentUser.displayName;
        this.review.submissionUserId = SubmissionItem.submissionUserId;
        this.review.submissionDisplayName = SubmissionItem.submissionDisplayName;
        this.review.chapterId = SubmissionItem.chapterId;
        this.review.lCId = SubmissionItem.lCId;
        //console.log(this.review);
        dbReviewsRef.push(this.review)
        var uC = this.userCollection;
        var subUId = SubmissionItem.submissionUserId

        if(uC && subUId){
          var userData = uC.filter( newData => {
              return  (newData.uid == subUId );
          });
        }
        var uC = userData[0]
        //console.log(uC)
        var oV = Object.values(uC)
        var lP = parseFloat(userData[0].learningPoints) + parseFloat(this.review.rating)
        var uKey = oV[oV.length-1]
        
        //console.log(uKey)
        //console.log(lP)
        
        //console.log(this.review.rating)
        //console.log(SubmissionItem.submissionDisplayName)
        
        var uData = {
            displayName: SubmissionItem.submissionDisplayName,
            learningPoints: lP,
            uid: subUId
        }
        
        var updates = {};
        updates[uKey] = uData
        dbUserCollectionRef.update(updates)
      },
    },
    created() {
        this.$store.dispatch('setReviewsRef', dbReviewsRef)
        this.$store.dispatch('setUserCollectionRef', dbUserCollectionRef)
    }
}
</script>

<style type="text/css">
.user-answer-review {
    border-radius: .3rem;
    background-color: #E1F6F2;
    padding: 1em;
    margin-bottom: 1em;
}
.card-date {
    color: rgba(0,0,0,.2);
    float: right;
}

.row {
    margin-right: 0px;
    margin-left: 0px;
}

</style>


// WEBPACK FOOTER //
// src/components/Admin.vue